import styled from 'styled-components'

import { Scroll } from 'styles/Helpers'

type SidebarWrapperProps = {
  isReduced: boolean
}

export const SidebarWrapper = styled.aside<SidebarWrapperProps>`
  height: 100%;
  width: ${({ theme, isReduced }) =>
    isReduced ? theme.misc.sidebar.reducedWidth : theme.misc.sidebar.width};

  background-color: ${({ theme }) => theme.colors.primary};

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  transition: 0.3s;

  nav {
    flex: 1;

    display: flex;
    flex-direction: column;

    padding: ${({ theme }) => `20px 0 ${theme.spacings[6]}`};

    ${Scroll}

    a {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: ${({ theme }) => theme.spacings[4]};

      height: 48px;
      padding-left: 38px;

      color: #f9f9f9aa;

      white-space: nowrap;

      transition: 0.3s;

      svg {
        color: #f9f9f9aa;

        width: ${({ theme }) => theme.fontSizes.lg};
        min-width: ${({ theme }) => theme.fontSizes.lg};

        & + span {
          margin-left: 0;
        }
      }

      span {
        opacity: ${({ isReduced }) => (isReduced ? 0 : 1)};
        white-space: nowrap;
        transition: 0.3s;

        margin-left: ${({ theme }) =>
          `calc(${theme.fontSizes.lg} + ${theme.spacings[2]})`};
      }

      &:focus,
      &:hover {
        background-color: rgba(255, 255, 255, 0.05);
      }

      &.active {
        color: ${({ theme }) => theme.colors.white};
        background-color: rgba(255, 255, 255, 0.05);

        svg {
          color: ${({ theme }) => theme.colors.white};
        }
      }

      &.active::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 6px;
        background-color: #fff;
        border-top-right-radius: 99px;
        border-bottom-right-radius: 99px;
      }
    }

    a + a {
      margin-top: ${({ theme }) => theme.spacings[2]};
    }
  }
`
